// The property belongs to the camera order line, never to a separate inventory item.
(() => {
  const allowed = ['CN', 'EU', 'US', 'UK', 'AU'];
  let selectedPlug = null;
  class BallrFreePlug extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      if (!select || this.ready) return;
      this.ready = true;
      const requested = new URL(location.href).searchParams.get('plug');
      const code = selectedPlug || (allowed.includes(requested) ? requested : null);
      if (code) select.value = code + ' Plug';
      select.addEventListener('change', () => {
        const code = select.value.split(' ')[0];
        if (!allowed.includes(code)) return;
        selectedPlug = code;
        // Keep the choice through model changes, section refreshes and shared links.
        const url = new URL(location.href);
        url.searchParams.set('plug', code);
        history.replaceState(history.state, '', url);
        document.querySelectorAll('ballr-free-plug select').forEach(other => {other.value = select.value;});
      });
    }
  }
  if (!customElements.get('ballr-free-plug')) customElements.define('ballr-free-plug', BallrFreePlug);
})();
